import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { logoutUser } from "../../actions/authActions";

const Navbar = ({ auth, logoutUser }) => {
    const { user } = auth;

    const onLogoutClick = (e) => {
        e.preventDefault();
        logoutUser();
    };

    return (
        <div className="container-fluid p-0">
            <nav className="navbar navbar-expand-lg navbar-dark bg-primary">
                <a className="navbar-brand" href="/">
                    Cyber Nest
                </a>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarNavDropdown"
                    aria-controls="navbarNavDropdown"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNavDropdown">
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item dropdown">
                            <a
                                className="nav-link dropdown-toggle"
                                href="#"
                                id="settings"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                Settings
                            </a>
                            <div className="dropdown-menu" aria-labelledby="settings">
                                <a className="dropdown-item" href="#" onClick={onLogoutClick}>
                                    Logout
                                </a>
                                <a className="dropdown-item" href="/integrations">
                                    Integration
                                </a>
                            </div>
                        </li>
                        <li className="nav-item active">
                            <a className="nav-link" href="#" onClick={onLogoutClick}>
                                Logout ({user.name}) <FontAwesomeIcon icon={faSignOutAlt} />
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </div>
    );
};

Navbar.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, { logoutUser })(Navbar);
